<template>
  <div>
    <div class="app-top">
      <top-title :dataList="topTitleList" :height="300"></top-title>
    </div>
    <div>
      <div class="container" style="margin-top: 30px;">
        <div class="row">
          <div class="col-sm-12" style="margin-bottom: 20px;">当前播放视频：{{name}}</div>
          <div class="col-sm-12 video-play">
            <vue-aliplayer-v2 class="multiple-player" key="player" :source="source" ref="VueAliplayerV2" :options="options" />
          </div>
        </div>
      </div>
      <div style="margin: 20px 0 20px 0;text-align:center;">相关视频</div>
      <video-list />
    </div>
  </div>
</template>

<script>
import videoList from './components/videoList.vue'
import topTitle from '@/_myComponents/topTitle'
import API from '@/api/video'
import VueAliplayerV2 from 'vue-aliplayer-v2'
export default {
  components: { videoList, topTitle, VueAliplayerV2 },
  name: 'VideoDetail',
  data() {
    return {
      topTitleList: [
        {
          image: '',
          title: '视频教程',
          subTitle: '',
          backgroundImage: require('@/assets/images/bg/bg-5.jpg'),
          backgroundColor: `linear-gradient(rgba(${this.utils.hexToRgb(this.softPrice.softThemeColor)},0.5),rgba(${this.utils.hexToRgb(
            this.softPrice.softThemeColor
          )},0.1))`
        }
      ],
      code: '',
      options: {
        // source:'//player.alicdn.com/video/aliyunmedia.mp4',
        isLive: false, //切换为直播流的时候必填
        cover: '',
        width: '100%',
        height: '100%',
        videoWidth: '100%',
        videoHeight: '100%'
        // format: 'm3u8'  //切换为直播流的时候必填
      },
      source: '',
      // source: '//ivi.bupt.edu.cn/hls/cctv1.m3u8',
      show: true,
      isShowMultiple: false,
      name: ''
    }
  },
  watch: {
    '$route.params.code'() {
      this.code = this.$route.params.code
      this.getOne()
    }
  },
  computed: {},
  created() {
    this.code = this.$route.params.code
    this.getOne()
  },
  methods: {
    getOne() {
      API.getOne({ id: this.code }).then(res => {
        console.log(res)
        this.source = res.data.url
        this.options.cover = res.data.image
        this.name = res.data.title
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.app-top {
  margin-top: 58px;
}
.video-play {
  width: 100%;
  height: 50vh;
  .multiple-player {
    height: 50vh !important;
  }
}
</style>